import { useState } from "react";
import api from "../api";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [error, setError] = useState("");

  const submit = async e => {
    e.preventDefault();
    setError("");
    try {
      await api.post("/auth/forgot-password", { email });
      setSent(true);
    } catch (e) {
      setError(e?.response?.data?.error || "Fehler beim Senden.");
    }
  };

  return (
  <div style={{width:'100vw',margin:0,padding:0}}>
      <h2>Passwort vergessen</h2>
      {sent ? (
        <div style={{color:'#2e7d32',marginTop:24}}>
          Falls die E-Mail existiert, wurde eine Nachricht versendet.<br/>
          Prüfe dein Postfach und folge dem Link.
        </div>
      ) : (
        <form onSubmit={submit} style={{display:'flex',flexDirection:'column',gap:16}}>
          <input
            type="email"
            placeholder="E-Mail-Adresse"
            value={email}
            onChange={e=>setEmail(e.target.value)}
            required
            style={{padding:'12px',fontSize:'1rem'}}
          />
          <button className="hero-btn-primary" type="submit">Link anfordern</button>
          {error && <div style={{color:'#d32f2f'}}>{error}</div>}
        </form>
      )}
    </div>
  );
}
